import { render, staticRenderFns } from "./practice-danxiang.vue?vue&type=template&id=313011ee&scoped=true&"
import script from "./practice-danxiang.vue?vue&type=script&lang=ts&"
export * from "./practice-danxiang.vue?vue&type=script&lang=ts&"
import style0 from "./practice-danxiang.vue?vue&type=style&index=0&id=313011ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313011ee",
  null
  
)

export default component.exports